import { Form } from "@unform/web";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import AdminRoutes from "Routes/Components/Admin";

import { UsePaginatedFetch } from "Hooks/UsePaginatedFetch";

import Button from "Components/Admin/Buttons";
import Input from "Components/Admin/Form/Input";
import Loading from "Components/Admin/Loading";
import Section from "Components/Admin/Section";
import Table from "Components/Admin/Table";
import { TableActionLink, withRowLink } from "Components/Admin/TableRowLink";

import { columns, downloadColumns } from "./columns";
import * as S from "./styles";

const LINK_TITLE = "Abrir patrocinador — Ctrl/Cmd+clique para nova aba";

const detailPath = (row) =>
  row.id ? AdminRoutes.DetailSponsor.path.replace(":id", row.id) : null;

const ListSponsors = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});

  const cancelRequest = useRef(false);

  const {
    setStartFetch,
    progress,
    requestInProgress,
    firstResponseReceived,
    data,
  } = UsePaginatedFetch({
    method: "post",
    path: "/sponsors/list",
    body: { filters: { ...formData } },
    responseAccessor: "sponsors",
    pageSize: 1000,
    cancelRequest: cancelRequest,
  });

  useEffect(() => {
    if (!requestInProgress && !firstResponseReceived) {
      setStartFetch(true);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Section>
      <S.SectionWrapper>
        <S.Wrapper>
          <Form
            onSubmit={
              !requestInProgress
                ? (data) => {
                    setFormData(data);
                    setStartFetch(true);
                  }
                : null
            }
          >
            <Input
              name="id"
              label="ID da Empresa"
              placeholder="ID"
              type="text"
            />

            <Input
              name="name"
              label="Nome da Empresa"
              placeholder="Nome"
              type="text"
            />

            <Input name="cnpj" label="CNPJ" placeholder="CNPJ" type="text" />

            <Button
              type="submit"
              text={
                requestInProgress
                  ? progress
                    ? `Carregando ${progress}%...`
                    : "Carregando..."
                  : "Buscar"
              }
            />
            {requestInProgress && (
              <Button
                text="Cancelar requisição"
                variant="critical"
                onClick={() => {
                  cancelRequest.current = true;
                }}
              />
            )}
          </Form>

          <Button
            type="button"
            text="Nova Empresa"
            onClick={() => navigate(AdminRoutes.CreateSponsor.path)}
            width="200px"
          />

          {requestInProgress && !firstResponseReceived ? (
            <Loading />
          ) : (
            <Table
              name="Empresas Patrocinadoras"
              data={data}
              columns={[
                ...withRowLink(columns, {
                  accessor: "name",
                  to: detailPath,
                }),
                {
                  Header: "Ações",
                  accessor: "actions",
                  noSearch: true,
                  width: "70px",
                  Cell: ({ cell }) => (
                    <TableActionLink
                      to={detailPath(cell.row.original)}
                      title={LINK_TITLE}
                    />
                  ),
                },
              ]}
              downloadColumns={downloadColumns}
              disableDownloadButton={requestInProgress}
            />
          )}
        </S.Wrapper>
      </S.SectionWrapper>
    </Section>
  );
};

export default ListSponsors;
